import {Injectable} from '@angular/core';
import {SpatialUtilService} from '../spatial-util.service';

@Injectable({
    providedIn: 'root'
})
export class PolygonUtilService {
    title = 'PolygonUtilService';

    constructor(private spatialUtilService: SpatialUtilService) {}

    /* eslint-disable @typescript-eslint/no-explicit-any */
    getPolygonRing(selectedLines: any[], points?: any[]) {
        console.debug(this.title, 'getPolygonRing');

        const pointGeometries = [];

        const addedPointInfoList = [
            {
                pointid: selectedLines[0].attributes.frompointid,
                lineid: selectedLines[0].attributes.id
            },
            {
                pointid: selectedLines[0].attributes.topointid,
                lineid: selectedLines[0].attributes.id
            }
        ];

        let allPointsFound = true;

        while (addedPointInfoList.length < selectedLines.length && allPointsFound) {
            const fromPointInfo = addedPointInfoList[addedPointInfoList.length - 1];
            const toPointInfo = this.getNextToPoint(fromPointInfo, addedPointInfoList, selectedLines);

            if (toPointInfo) {
                addedPointInfoList.push(toPointInfo);
            } else {
                allPointsFound = false;
            }
        }

        if (allPointsFound) {
            const pointFeatures = this.getPointsByPointInfo(addedPointInfoList, selectedLines, points);
            const lineIds = [];

            addedPointInfoList.forEach(addedPointId => {
                pointFeatures.forEach(pointFeature => {
                    if (addedPointId.pointid === pointFeature.attributes.id) {
                        pointGeometries.push(pointFeature.geometry);
                        lineIds.push(addedPointId.lineid);
                    }
                });
            });

            const ids = [];

            lineIds.forEach(item => {
                if (!ids.includes(item)) {
                    ids.push(item);
                }
            });

            selectedLines.forEach(item => {
                if (!ids.includes(item.attributes.id)) {
                    ids.push(item.attributes.id);
                }
            });

            pointGeometries.push(pointGeometries[0]);

            const pointCountMap = {};

            //Two point check (All points should appear twice)

            selectedLines.forEach(item => {
                const i = `${item.attributes.frompointid}`;
                const j = `${item.attributes.topointid}`;

                if (!pointCountMap[i]) {
                    pointCountMap[i] = 1;
                } else {
                    pointCountMap[i] = 2;
                }

                if (!pointCountMap[j]) {
                    pointCountMap[j] = 1;
                } else {
                    pointCountMap[j] = 2;
                }
            });

            if (!Object.values(pointCountMap).includes(1)) {
                if (pointGeometries) {
                    const polygonGeometry = new (window as any).esri.geometry.Polygon();
                    polygonGeometry.setSpatialReference(pointGeometries[0].spatialReference);

                    if (!polygonGeometry.isClockwise(pointGeometries)) {
                        pointGeometries.reverse();
                        ids.reverse();
                    }
                }

                return {ring: pointGeometries, lineids: ids.map(id => `[${id}]`).join(',')};
            }
        }

        return {};
    }

    private getNextToPoint(pointInfo: any, addedPointInfoList: any[], selectedLines: any[]) {
        console.debug(this.title, 'getNextToPoint');

        const addedPointIds = addedPointInfoList.map(addedPointInfo => addedPointInfo.pointid);

        let output = undefined;

        selectedLines.forEach(line => {
            if (line.attributes.frompointid === pointInfo.pointid && !addedPointIds.includes(line.attributes.topointid)) {
                if (!output || pointInfo.lineid !== line.attributes.id) {
                    output = {pointid: line.attributes.topointid, lineid: line.attributes.id};
                }
            } else if (line.attributes.topointid === pointInfo.pointid && !addedPointIds.includes(line.attributes.frompointid)) {
                if (!output || pointInfo.lineid !== line.attributes.id) {
                    output = {pointid: line.attributes.frompointid, lineid: line.attributes.id};
                }
            }
        });

        return output;
    }

    private getPointsByPointInfo(pointInfoList: any[], selectedLines: any[], points?: any[]) {
        console.debug(this.title, 'getPointsByPointInfo');

        const output = [];

        pointInfoList.forEach(pointInfo => {
            let point;
            if (points) {
                point = points.find(point => point.attributes.id === pointInfo.pointid);
            } else {
                point = this.spatialUtilService
                    .getGraphics(this.spatialUtilService.getPointMapLayer())
                    .find(graphic => graphic.attributes.id === pointInfo.pointid);
            }

            if (point) {
                output.push(point);
            } else {
                let geometry = undefined;
                selectedLines.forEach(line => {
                    if (line.attributes.frompointid === pointInfo.pointid) {
                        geometry = {x: line.geometry.paths[0][0][0], y: line.geometry.paths[0][0][1]};
                        geometry.spatialReference = line.geometry.spatialReference;
                    }
                    if (line.attributes.topointid === pointInfo.pointid) {
                        geometry = {x: line.geometry.paths[0][1][0], y: line.geometry.paths[0][1][1]};
                        geometry.spatialReference = line.geometry.spatialReference;
                    }
                });

                if (geometry) {
                    point = {geometry: geometry, attributes: {id: pointInfo.pointid}};
                    output.push(point);
                }
            }
        });

        return output;
    }
}
